/* eslint semi: 1 */

const defaultAppData = {
    builds: []
};

export default (state = defaultAppData, action) => {

    const { type, payload } = action;

    switch(type) {
        case 'ADD_BUILDS':
            return {
                ...state,
                builds: [...payload.builds]
            };
        default:
            return state;
    }

};



// WEBPACK FOOTER //
// ./src/reducers/app-reducer.js